if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.currentIndex = 0;
        this.content = this.querySelector('.product-media-modal__content');
        this.currentCounter = this.querySelector('[data-product-modal-current]');
        this.totalCounter = this.querySelector('[data-product-modal-total]');
        this.previousButton = this.querySelector('.product-media-modal__nav--prev');
        this.nextButton = this.querySelector('.product-media-modal__nav--next');
        this.controls = this.querySelector('.product-media-modal__controls');
        this.cursorCue = this.querySelector('.product-media-modal__cursor');
        this.closeButton = this.querySelector('.product-media-modal__toggle');

        this.previousButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.showRelativeMedia(-1);
        });

        this.nextButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.showRelativeMedia(1);
        });

        this.controls?.addEventListener('pointerup', (event) => event.stopPropagation());
        this.controls?.addEventListener('click', (event) => event.stopPropagation());
        this.closeButton?.addEventListener('pointerup', (event) => event.stopPropagation());

        this.content?.addEventListener('click', (event) => {
          const activeMedia = event.target.closest('[data-media-id].active');
          if (!activeMedia) return;

          event.preventDefault();
          this.hide();
        });

        this.addEventListener('mousemove', (event) => this.updateCursorCue(event));
        this.addEventListener('mouseleave', () => this.clearCursorCue());
        this.addEventListener('click', (event) => this.onModalClick(event));
      }

      hide() {
        this.clearCursorCue();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      onModalClick(event) {
        if (event.target.closest('.product-media-modal__toggle, .product-media-modal__controls')) return;

        const activeMedia = event.target.closest('.product-media-modal__content [data-media-id].active');
        if (event.target === this || event.target.closest('.product-media-modal__dialog') || activeMedia) {
          event.preventDefault();
          this.hide();
        }
      }

      updateCursorCue(event) {
        if (!this.hasAttribute('open') || !this.cursorCue) return;
        if (event.target.closest('.product-media-modal__toggle, .product-media-modal__controls')) {
          this.clearCursorCue();
          return;
        }

        const mediaItems = this.getActiveMediaItems();
        if (mediaItems.length < 2) {
          this.clearCursorCue();
          return;
        }

        this.cursorCue.style.setProperty('--product-modal-cursor-x', `${event.clientX}px`);
        this.cursorCue.style.setProperty('--product-modal-cursor-y', `${event.clientY}px`);
        this.classList.add('is-cursor-active');
      }

      clearCursorCue() {
        this.classList.remove('is-cursor-active');
      }

      showActiveMedia() {
        const openedMediaId = this.openedBy.getAttribute('data-media-id');
        this.activeMediaIds = this.getGalleryMediaIds(openedMediaId);
        const targetIndex = this.getMediaItems().findIndex((media) => media.dataset.mediaId === openedMediaId);

        this.setActiveMedia(targetIndex >= 0 ? targetIndex : 0);
      }

      showRelativeMedia(step) {
        const mediaItems = this.getActiveMediaItems();
        if (!mediaItems.length) return;

        const currentMedia = this.getMediaItems()[this.currentIndex];
        const currentActiveIndex = Math.max(
          mediaItems.findIndex((media) => media.dataset.mediaId === currentMedia?.dataset.mediaId),
          0
        );
        const nextMedia = mediaItems[(currentActiveIndex + step + mediaItems.length) % mediaItems.length];
        const nextIndex = this.getMediaItems().findIndex((media) => media.dataset.mediaId === nextMedia.dataset.mediaId);
        this.setActiveMedia(nextIndex);
      }

      setActiveMedia(index) {
        const mediaItems = this.getMediaItems();
        const activeMedia = mediaItems[index];
        if (!activeMedia) return;

        mediaItems.forEach((element) => {
          element.classList.remove('active');
          element.hidden = this.activeMediaIds?.length ? !this.activeMediaIds.includes(element.dataset.mediaId) : false;
        });

        this.currentIndex = index;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        this.updateCounter();

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      updateCounter() {
        const mediaItems = this.getActiveMediaItems();
        const activeMedia = this.getMediaItems()[this.currentIndex];
        const activeIndex = mediaItems.findIndex((media) => media.dataset.mediaId === activeMedia?.dataset.mediaId);
        const total = mediaItems.length || this.getMediaItems().length;
        if (this.currentCounter) this.currentCounter.textContent = `${Math.max(activeIndex, 0) + 1}`;
        if (this.totalCounter) this.totalCounter.textContent = `${total}`;
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content [data-media-id]'));
      }

      getActiveMediaItems() {
        const mediaItems = this.getMediaItems();
        if (!this.activeMediaIds?.length) return mediaItems;

        return this.activeMediaIds
          .map((mediaId) => mediaItems.find((media) => media.dataset.mediaId === mediaId))
          .filter(Boolean);
      }

      getGalleryMediaIds(openedMediaId) {
        const opener = document.querySelector(`.product__media-toggle[data-media-id="${openedMediaId}"]`);
        const gallery = opener?.closest('media-gallery');
        const galleryItems = gallery?.getCurrentBatchMediaItems?.();
        if (!galleryItems?.length) return [];

        return galleryItems.map((item) => item.dataset.mediaId.split('-').pop());
      }
    }
  );
}
